import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "grid gap-8 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 mb-8" }

import { computed, ref, toRefs } from 'vue';
import { AccountPresenter, CandyMachineV2Account } from '@/models';


export default /*#__PURE__*/_defineComponent({
  props: {
    account: null,
    presenter: null
  },
  setup(__props: any) {

const props = __props as {
  account: CandyMachineV2Account,
  presenter: AccountPresenter,
}



const { account } = toRefs(props);
const perPage = 6;
const page = ref(1);
const configLines = computed(() => account.value.configLines.slice(
  (page.value - 1) * perPage,
  page.value * perPage,
));

return (_ctx: any,_cache: any) => {
  const _component_config_line_card = _resolveComponent("config-line-card")!
  const _component_base_pagination = _resolveComponent("base-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(configLines), (configLine) => {
        return (_openBlock(), _createElementBlock("li", {
          key: configLine.uri
        }, [
          _createVNode(_component_config_line_card, { "config-line": configLine }, null, 8, ["config-line"])
        ]))
      }), 128))
    ]),
    _createVNode(_component_base_pagination, {
      page: page.value,
      "onUpdate:page": _cache[0] || (_cache[0] = ($event: any) => ((page).value = $event)),
      perPage: perPage,
      total: _unref(account).configLines.length
    }, null, 8, ["page", "total"])
  ]))
}
}

})